// Cached API base URL loaded from aws-exports.json.
let BIBLIO_FULLTEXT_API_URL = ""

export interface BiblioChunkContextChunk {
  sourceId: string
  chunkId: string
  page?: string | number
  content: string
  contentKind?: string
  headings?: string[]
  citation?: string
  title?: string
  publicationYear?: string | number
  contentTruncated?: boolean
}

export interface BiblioChunkContextResponse {
  sourceId: string
  contextMode?: string
  targetChunkId?: string
  chunks: BiblioChunkContextChunk[]
  returnedCount?: number
  requestedChunkCount?: number
  missingChunkIds?: string[]
  truncated?: boolean
  maxChunks?: number
}

export interface GetBiblioChunkContextRequest {
  sourceId: string
  chunkId?: string
  page?: number
  pageFrom?: number
  pageTo?: number
  before?: number
  after?: number
  maxChunks?: number
  includeMetadata?: boolean
  maxContentCharsPerChunk?: number
}

async function loadApiUrl(): Promise<string> {
  if (BIBLIO_FULLTEXT_API_URL) return BIBLIO_FULLTEXT_API_URL

  try {
    const response = await fetch("/aws-exports.json")
    const config = await response.json()
    const baseUrl = import.meta.env.VITE_API_URL || config.apiUrl || ""
    BIBLIO_FULLTEXT_API_URL = baseUrl
      ? `${baseUrl}/api/biblio/fulltext`
      : "/api/biblio/fulltext"
    return BIBLIO_FULLTEXT_API_URL
  } catch (error) {
    console.error("Failed to load API URL from aws-exports.json:", error)
    throw new Error("Biblio fulltext API URL not configured")
  }
}

export async function getBiblioChunkContext(
  request: GetBiblioChunkContextRequest,
  accessToken: string
): Promise<BiblioChunkContextResponse> {
  const apiUrl = await loadApiUrl()

  const response = await fetch(`${apiUrl}/chunk-context`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(request),
  })

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}))
    throw new Error(errorData.error || `HTTP error! status: ${response.status}`)
  }

  return response.json()
}
